"use client"

import { t } from "@/languages/i18n"
import { CaretDownOutlined, CaretUpOutlined, CheckCircleOutlined, CloseCircleOutlined, PlusCircleOutlined } from "@ant-design/icons"
import { Button, Space, Typography } from "antd"
import React from "react"
import { PublishProps } from "../../../../lib/config/types"
import { LanguagePublish, StatusPublish } from "../../post/pages/StatusPublish"
const { Title, Text } = Typography

interface LocalizationEntry {
    id: number
    locale: string
}

interface ExtendedPublishProps extends PublishProps {
    loading?: boolean;
    canSubmit?: boolean;
    isEditMode?: boolean
    onCancle?: () => void
    type?: string;
    localizations?: LocalizationEntry[]
    onNavigateToLocale?: (id: number) => void
    onCreateLocale?: (targetLocale: string) => void
}

const Publish: React.FC<ExtendedPublishProps> = ({
    onSubmit,
    isCreateEdit,
    setStatus,
    status,
    setPublishDate,
    onPageTypeChanged,
    language,
    setLanguages,
    loading,
    canSubmit,
    isEditMode,
    onCancle,
    type,
    localizations = [],
    onNavigateToLocale,
    onCreateLocale
}) => {
    const [isPublishListVisible, setPublishListVisible] = React.useState(true)

    const getButtonLabel = () => {
        if (type === "translate") return (t("Tạo bản dịch"));
        return isEditMode ? t("Cập nhật") : t("Xuất bản");
    };

    const getButtonIcon = () => {
        if (type === "translate" || !isEditMode) return <PlusCircleOutlined />;
        return <CheckCircleOutlined />;
    };

    return (
        <div className="publish border-gray-300 border rounded-[10px] mb-5">
            <div className="flex justify-between items-center px-4 py-3 border-b">
                <Title level={4} className="!m-0">
                    {t("Publish")}
                </Title>
                <Button
                    onClick={() => setPublishListVisible(!isPublishListVisible)}
                    className="flex items-center"
                    icon={isPublishListVisible ? <CaretDownOutlined /> : <CaretUpOutlined />}
                    type="text"
                />
            </div>

            {isPublishListVisible && (
                <div>
                    <Space direction="vertical" className="px-4 py-4">
                        <StatusPublish setStatus={setStatus} status={status} />
                        <LanguagePublish
                            language={language}
                            setLanguages={setLanguages}
                            isCreateEdit={isCreateEdit}
                            localizations={localizations}
                            onNavigateToLocale={onNavigateToLocale}
                            onCreateLocale={onCreateLocale}
                        />
                    </Space>
                    <div className="flex justify-end border-t pt-3 px-4 bg-[#f6f7f7] rounded-b-[10px] h-14">
                        <Button
                            type="primary"
                            onClick={onSubmit}
                            loading={loading}
                            disabled={loading || !canSubmit}
                            icon={getButtonIcon()}
                            
                        >
                            {getButtonLabel()}
                        </Button>
                    </div>
                </div>
            )}
        </div>
    )
}

export default Publish
